import { useEffect, useMemo } from 'react';

const noop = () => {};

export const useCallbackWithTimeout = (
  callback: typeof noop,
  delay: number,
) => {
  const [fn, cleanup] = useMemo(() => {
    const timeoutId = setTimeout(() => {
      callback();
    }, delay);
    return [
      () => {
        clearTimeout(timeoutId);
        callback();
      },
      () => clearTimeout(timeoutId),
    ];
  }, [callback, delay]);

  useEffect(() => cleanup, [cleanup]);

  return fn;
};
